import React from 'react';
import { Card, Box, Typography } from '../primitives';
import { CardContent } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Composed DashboardCard component
 * Reusable card component ready to be customized for broader use
 */
const DashboardCard = ({ 
  title, 
  children, 
  elevation = 2,
  sx = {},
  ...props 
}) => {
  const theme = useTheme();

  return (
    <Card
      elevation={elevation}
      sx={{
        background: theme.palette.background.paper,
        ...sx,
      }}
      {...props}
    >
      <CardContent>
        {title && (
          <Typography variant="h5" component="h2" gutterBottom>
            {title}
          </Typography>
        )}
        <Box sx={{ mt: title ? 2 : 0 }}>
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};

export default DashboardCard;

